<template>
  <div class="signature-pad-wrapper">
    <div class="signature-pad" @click="removeSignHere">
      <div v-if="showSignHere" class="sign-here">sign here</div>
      <VueSignaturePad
        class="signature"
        height="150px"
        ref="signaturePad"
        :options="options"
      />
    </div>
    <div class="link" @click="clearSignaturePad">clear</div>
  </div>
</template>

<script>
  import SignaturePad from 'signature_pad'

  export default {
    name: 'SignaturePad',

    data() {
      return {
        options: { 
          onBegin: this.removeSignHere, 
          onEnd: this.sendSignature 
        },
        showSignHere: true,
      }
    },
    
    methods: {
      clearSignaturePad() {
        this.$refs.signaturePad.clearSignature()
      },

      removeSignHere() {
        this.showSignHere = false
      },

      sendSignature() {
        const signatureData = this.$refs.signaturePad.saveSignature()
        this.$emit('setData', 'signatureFile', signatureData.data)
      },
    }
  }
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.signature-pad-wrapper
  .signature-pad
    align-content: center
    border: 1px solid $primary-color
    border-radius: 8px
    display: flex
    justify-content: center
    padding: 1rem 1rem 1.25rem 1rem
    position: relative

    .sign-here
      color: $negative-color
      content: "sign here"
      font-family: cursive
      font-size: 1.5rem
      font-style: italic
      font-weight: 600
      letter-spacing: 2px
      opacity: 0.7
      position: absolute
      top: 70px

  .signature
    border-bottom: 1px solid $primary-color
    overflow: hidden
</style>